module.exports = __webpack_public_path__ + "static/img/base-con-img.36d187a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unifiedProcess/base-con-img.png
// module id = 4asC
// module chunks = 0